import type { PhaseReturn } from "../../../common/types";

const newPhaseAfterTradeDeadline = async (): Promise<PhaseReturn> => {
	return {};
};

export default newPhaseAfterTradeDeadline;
